// extracted by mini-css-extract-plugin
export var container = "styles-module__container___cQzjZ";
export var imageContainer = "styles-module__imageContainer___T1uS7";
export var image = "styles-module__image___VPMyA";
export var title = "styles-module__title___qxTP6";